/**
 * 配列の各要素の間に要素を挿入する
 * @param arr 元の配列
 * @param fun 挿入する要素を生成する関数
 * @return 挿入された配列 (例: [a, x, b, x, c, x, d])
 */
export const insertBetween = <T>(arr: Array<T>, fun: (index: number) => T) =>
  arr.flatMap((e, index) => [e, fun(index)]).slice(0, -1);
